(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
      
jQuery(function ($) {
  "use strict";
  $(document).ready(function () {
    var loadProductRecommendationsIntoSection = function () {
      var productRecommendationsSection = document.querySelector(".product-recommendations");
      if (productRecommendationsSection === null) { return; }
      var productId = productRecommendationsSection.dataset.productId;
      var limit = productRecommendationsSection.dataset.limit;
      var requestUrl = "/recommendations/products?section_id=product-recommendations&limit=" + limit + "&product_id=" + productId;
      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);
      request.onload = function () {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement("div");
          container.innerHTML = request.response;
          console.log("request.response=====00000000000000000000000000=========>",request.response)
          productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;

          if ($('.main-carousel').length) {
            var carousel = $('.main-carousel').flickity({
              prevNextButtons: true,
              lazyLoad: 1,
              wrapAround: true,
              pageDots: false,
              setGallerySize: true,
              freeScroll: false,
              contain: true,
              arrowShape: { "x0": 10, "x1": 85, "y1": 45, "x2": 85, "y2": 35, "x3": 25 }
            });

            carousel.on('lazyLoad.flickity', function (event, cellElement) {
              var target = event.target;
              $(target).addClass('loaded');
            });
             
            carousel.on('change.flickity', function (event, index) {
              var video_handle = $(event.target).find('video').data('handle');
              var is_lazyloaded = $(event.target).find('video').hasClass(video_handle); 
              if (video_handle !== undefined && is_lazyloaded === true) {
                yall({
                  observeChanges: true,
                  lazyClass: video_handle
                });
              }
            }); 
          }

        }
      };
      request.send();
    };
    document.addEventListener("shopify:section:load", function (event) {
      if (event.detail.sectionId === "product-recommendations") {
        loadProductRecommendationsIntoSection();
      }
    });
    loadProductRecommendationsIntoSection();
  });
});

  } catch(e) { console.error(e); }
})();
})();
